import type { AxiosInstance } from 'axios'

import type { Tag } from '@/types'

import BaseService from './BaseService'

export default class TagService extends BaseService<Tag> {
  constructor(client: AxiosInstance) {
    super(client, 'tag')
  }
}
